import React from 'react';
import { useTranslation } from "react-i18next";
import { Grid } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import DyanamicDropdown from 'components/Elements/DynamicDropdown';
import { useFilters } from '../FilterContext';
import { useUsers } from './hooks/useUsers';
import { useFilterInitialization } from './hooks/useFilterInitialization';
import { getLocalStorageData } from 'helpers/utils';
import { SHOW_ALL_OPTION } from '../constants';

export const UserFilter = () => {
  const { t } = useTranslation();
  const { filterValues, updateFilter, isShowAll, initialValues, config } = useFilters();
  const showAllEnabled = isShowAll('user');
  const userFilterConfig = config?.filters?.user;
  const fetchFn = typeof userFilterConfig === 'object' ? userFilterConfig.fetchFn : undefined;
  const users = useUsers(showAllEnabled, fetchFn);
  const { id: userId } = getLocalStorageData("me");

  // Clean, declarative initialization - default to "Current User" unless 'all' is stored
  useFilterInitialization('user', users, {
    waitForData: true,
    persistAll: true,
    getDefaultValue: () => {
      // Check if 'all' is stored in initialValues
      const storedValue = initialValues.user;
      
      // If 'all' is stored, use the show all option with empty id
      if (storedValue === 'all') {
        return SHOW_ALL_OPTION;
      }
      
      // Otherwise default to current user
      return {
        id: userId,
        name: t("option.currentUser"),
        isCurrentUser: true
      };
    },
    getParams: (item) => ({ 
      userId: item.id || '',
      myFeedback: item.isCurrentUser === true || item.id === userId
    })
  });

  if (!filterValues.user) {
    return null;
  }

  return (
    <Grid item lg={3} md={6} xs={12}>
      <DyanamicDropdown
        dataSource={users}
        columns={[{ name: 'name', id: 1, minWidth: '130px' }]}
        columnsMinWidths={[140, 140, 140, 140, 140]}
        showHeader={false}
        width="100%"
        placeholder={t("placeholder.selectUser")}
        onChange={item => updateFilter('user', item, { 
          userId: item.id || '',
          myFeedback: item.isCurrentUser === true || item.id === userId
        }, true)}
        selectdValueToshow="name"
        selectedValue={filterValues.user?.value}
        label={t("label.filterByUser")}
        isServerSide={false}
        icon={<FilterListIcon style={{ color: 'rgb(48, 122, 215)' }} />}
        required={false}
        showBorderColor
      />
    </Grid>
  );
}; 
